import React, { useState, useEffect, useRef, useCallback, forwardRef, useImperativeHandle } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { FaArrowLeft, FaAndroid, FaCompress, FaExpand, FaInfoCircle } from "react-icons/fa";
import { MdAspectRatio } from "react-icons/md";
// import { MdNotificationsActive } from "react-icons/md";
// import { PiAppWindow, PiGridFour } from "react-icons/pi";

import { enWebPage } from "../../../lib/ConstCommand";
import { enTokenCMD } from "../../../lib/classTalk/CodeEnum";

import { unsubscribe } from "../../../lib/MediaSoupClient";
import {
    xmitCmd_MessageForSmartTV
} from "../../../lib/RabbitmqClient";
import { exitPageFullscreen, usePageFullscreen } from "../../../hooks/usePageFullscreen";

// import showTeacherImg from "../../image/liveTool/showTeacherScreen.png";
// import hideTeacherImg from "../../image/liveTool/hideTeacherScreen.png";

const SmartTVControlTool = forwardRef(({ currentPageType, userNickname, teacherInfo, performLiveInfo, performLiveStatusInfo, smartTVBindInfo, isConnectedOnScreenApp, list_isConnectedOnScreenApp, onToggleImageView, onToggleViewMode, objectFitMode, onToggleObjectFit, onClickConnectApp, handleSelectedFunc }, ref) => {
    const { t } = useTranslation();
    let history = useHistory();

    const [lViewMode, setViewMode] = useState("default");
    // const [lViewMode, setViewMode] = useState("multi-view");
    const [imageViewVisibility, setImageViewVisibility] = useState("visible");
    const [isConnectApp, setIsConnectApp] = useState(isConnectedOnScreenApp);
    const { isFullscreen, toggleFullscreen } = usePageFullscreen(); // 260803 하단 바에서 전체화면 ON/OFF 상태를 제어한다.
    // const [isDisabled, setIsDisabled] = useState(false);

    useImperativeHandle(ref, () => ({
        // updateDisabled: value => setIsDisabled(value),
        updateViewMode: value => {
            if (value !== lViewMode) {
                setViewMode(value);
            }
        },
        updateControlTool: value => update(value),
        getlViewMode : ()=>{
            return lViewMode;
        }
    }));

    useEffect(() => {
        setIsConnectApp(isConnectedOnScreenApp);
    }, [isConnectedOnScreenApp]);

    const update = ({ viewMode, visibility, isDisabled }) => {
        let msg = `updateView - viewMode[${viewMode}], visibility[${visibility}], isDisabled[${isDisabled}]`;
        console.log(msg);

        if (viewMode && viewMode !== lViewMode) {
            setViewMode(viewMode);
        }

        if (visibility && visibility !== imageViewVisibility) {
            setImageViewVisibility(visibility);
        }

        /* if (isDisabled !== undefined) {
            setIsDisabled(isDisabled);
        } */
    }

    const onClickGoBack = () => {
        // console.log("onClickGoBack - call history.goBack");
        // history.goBack();
        // console.log("onClickGoBack - call location.reload");
        // window.location.reload();
        if (performLiveInfo.liveSeq > -1) { // live에 입장한 case by hjkim 20231211
            if (performLiveInfo.liveStatus === "Y" && performLiveStatusInfo.connectStatus === "on") {
                unsubscribe(false, true, true);
            }

            if (list_isConnectedOnScreenApp && list_isConnectedOnScreenApp.length > 0) {
                for (let i = 0; i < list_isConnectedOnScreenApp.length; i++) {
                    let info = list_isConnectedOnScreenApp[i];
                    xmitCmd_MessageForSmartTV("smart_tv", "ct_SmartTVLogout", enTokenCMD.ct_Logout, info.userSeq, info.userNickname, performLiveInfo.liveSeq, false);

                    if (info.isConnectedOnScreenApp) {
                        xmitCmd_MessageForSmartTV("android", "ct_SmartTVLogout", enTokenCMD.ct_Logout, info.userSeq, info.userNickname, performLiveInfo.liveSeq, false);
                    }
                }
            }
        }

        exitPageFullscreen(); // 260803 로그인 페이지로 돌아가기 전에 전체화면을 해제한다.
        if (currentPageType === enWebPage.SmartTV) {
            window.location.replace(`/smarttv-login/${performLiveInfo.liveSeq}`);
        } else {
            window.location.replace(`/group-smarttv-login/${performLiveInfo.liveSeq}`);
        }
    }

    const onClickImageViewVisibility = () => {
        if (imageViewVisibility === "hidden") {
            setImageViewVisibility("visible");
            onToggleImageView({ display: "block", value: "visible" });
        } else {
            setImageViewVisibility("hidden");
            onToggleImageView({ display: "none", value: "hidden" });
        }
    }

    const onClickChangeViewMode = () => {
        if (lViewMode === "default") {
            setViewMode("multi-view");
            // setIsDisabled(true);
            onToggleViewMode({ value: "multi-view" });
        } else {
            setViewMode("default");
            onToggleViewMode({ value: "default" });
        }
    }

    /* const onClickConnectApp = () => {
        if (isConnectApp) {
            handleSelectedFunc({ selectedFunc: "TRY_DISCONN_APP" });
        } else {
            handleSelectedFunc({ selectedFunc: "TRY_CONN_APP" });
        }
    } */

    const onClickRequestConnInfo = () => {
        if (smartTVBindInfo.bindKeyArr.length === 0 || smartTVBindInfo.startSeqOfSmartTV === -1) {
            handleSelectedFunc({ selectedFunc: "TRY_REQ_CONN_INFO" });
        }
    }

    return (
        <div className="live-toolbar-area bottom small">
            <div className="toolbar-landscape">
                <button type="button" className="d-flex hiclasstv-button p-2" title={t("뒤로가기", { ns: "live" })} onClick={onClickGoBack}>
                    <FaArrowLeft className="font-ml" style={{ color: 'rgb(158, 158, 158)' }} alt={t("뒤로가기", { ns: "live" })} aria-hidden="true" />
                </button>
                {/* 260803 SmartTV 공통 하단 바에 전체화면 ON/OFF 버튼을 배치한다. */}
                <button type="button" className="d-flex hiclasstv-button p-2" title={isFullscreen ? "전체화면 OFF" : "전체화면 ON"} aria-label={isFullscreen ? "전체화면 OFF" : "전체화면 ON"} onClick={toggleFullscreen}>
                    {isFullscreen
                        ? <FaCompress className="font-ml" style={{ color: 'rgb(158, 158, 158)' }} aria-hidden="true" />
                        : <FaExpand className="font-ml" style={{ color: 'rgb(158, 158, 158)' }} aria-hidden="true" />}
                </button>
                {/* 260805 SmartTV 영상의 채움/맞춤 표시 방식을 하단 바에서 전환한다. */}
                <button type="button" className="d-flex hiclasstv-button p-2" title={objectFitMode === "fill" ? "화면 비율 CONTAIN" : "화면 비율 FILL"} aria-label={objectFitMode === "fill" ? "화면 비율 CONTAIN" : "화면 비율 FILL"} onClick={onToggleObjectFit}>
                    <MdAspectRatio className="font-ml" style={{ color: objectFitMode === "contain" ? 'rgb(55, 230, 71)' : 'rgb(158, 158, 158)' }} aria-hidden="true" />
                </button>
                <button type="button" className="d-flex hiclasstv-button p-2" title={lViewMode !== "default" ? t("학생_화면_닫기", { ns: "live" }) : imageViewVisibility === "hidden" ? t("학생_화면_보기", { ns: "live" }) : t("학생_화면_닫기", { ns: "live" })} disabled={/* isDisabled ||  */lViewMode !== "default"} onClick={onClickImageViewVisibility}>
                    {
                        lViewMode !== "default" ? 
                            <img className="hiclasstv-live-icon" src="/images/smartTVTool/showTeacherScreenDisable.png" alt={t("학생_화면_닫기", { ns: "live" })} aria-hidden="true" /> :
                        imageViewVisibility === "hidden" ?
                            <img className="hiclasstv-live-icon" src="/images/smartTVTool/showTeacherScreen.png" alt={t("학생_화면_보기", { ns: "live" })} aria-hidden="true" /> :
                            <img className="hiclasstv-live-icon" src="/images/smartTVTool/hideTeacherScreen.png" alt={t("학생_화면_닫기", { ns: "live" })} aria-hidden="true" />
                    }
                </button>
                {
                    currentPageType === enWebPage.GroupSmartTV &&
                    <button type="button" className="d-flex hiclasstv-button p-2" title={lViewMode === "default" ? t("분할_모드_전환", { ns: "live" }) : t("기본_화면_전환", { ns: "live" })} disabled={imageViewVisibility === "hidden"} onClick={onClickChangeViewMode}>
                        {
                            imageViewVisibility === "hidden" ? 
                                <img className="hiclasstv-live-icon" src="/images/smartTVTool/showMultiView4Disable.png" alt={t("분할_모드_전환", { ns: "live" })} aria-hidden="true" /> :
                            lViewMode === "default" ?
                                <img className="hiclasstv-live-icon" src="/images/smartTVTool/showMultiView4.png" alt={t("분할_모드_전환", { ns: "live" })} aria-hidden="true" /> :
                                <img className="hiclasstv-live-icon" src="/images/smartTVTool/showDefaultView.png" alt={t("기본_화면_전환", { ns: "live" })} aria-hidden="true" />
                        }
                    </button>
                }
                <button type="button" className="d-flex hiclasstv-button p-2" title={isConnectApp ? t("앱_연결_끊기", { ns: "live" }) : t("앱_연결하기", { ns: "live" })} onClick={onClickConnectApp}>
                    {
                        isConnectApp ?
                            <FaAndroid className="font-ml" style={{ color: 'rgb(55, 230, 71)' }} alt={t("앱_연결_끊기", { ns: "live" })} aria-hidden="true" /> :
                            <FaAndroid className="font-ml" style={{ color: 'rgb(255, 0, 0)' }} alt={t("앱_연결하기", { ns: "live" })} aria-hidden="true" />
                    }
                </button>
                {
                    !(smartTVBindInfo.bindKeyArr.length > 0 || smartTVBindInfo.startSeqOfSmartTV > -1) &&
                    <button type="button" className="d-flex hiclasstv-button p-2" title={t("스마트_티브이_연결_정보_요청", { ns: "live" })} disabled={smartTVBindInfo.bindKeyArr.length > 0 || smartTVBindInfo.startSeqOfSmartTV > -1} onClick={onClickRequestConnInfo}>
                        <FaInfoCircle
                            className="font-ml"
                            style={{ color: smartTVBindInfo.bindKeyArr.length > 0 || smartTVBindInfo.startSeqOfSmartTV > -1 ? 'lightgray' : 'rgb(55, 230, 71)' }}
                            alt={t("스마트_티브이_연결_정보_요청", { ns: "live" })}
                            aria-hidden="true"
                        />
                    </button>
                }
                <div className="d-flex align-items-center w-100">
                    <div className="d-flex align-items-center" style={{ minWidth: '1%', width: '100%', maxWidth: 'max-content' }}>
                        <span className="web-list-text w-100 px-1" title={`[${t("진행자", { ns: "live" })}] ${teacherInfo.userNickname}`}>
                            <b>[{t("진행자", { ns: "live" })}] {teacherInfo.userNickname}&nbsp;&nbsp;</b>
                        </span>|
                    </div>
                    <div className="d-flex" style={{ minWidth: '10%', width: '100%', maxWidth: 'max-content', visibility: 'visible' }}>
                        <span className="web-list-text w-100 px-1" title={(currentPageType === enWebPage.SmartTV ? `[${t("공유_학생", { ns: "live" })}] ` : `[${t("공유_그룹", { ns: "live" })}] `) + userNickname}>
                            {(currentPageType === enWebPage.SmartTV ? `[${t("공유_학생", { ns: "live" })}] ` : `[${t("공유_그룹", { ns: "live" })}] `) + userNickname}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
});

export default SmartTVControlTool;
